var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_244)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 24.2632C83.7488 23.8923 83.5047 23.5722 83.1842 23.3463C82.8637 23.1203 82.4824 22.9994 82.0918 23H24.9066C24.401 23 23.9162 23.2032 23.5587 23.5649C23.2012 23.9265 23.0004 24.4171 23.0004 24.9286V36.4999C23.0004 37.0114 23.2012 37.5019 23.5587 37.8636C23.9162 38.2253 24.401 38.4285 24.9066 38.4285H25.8597V47.107C25.8605 47.5322 26.0002 47.9452 26.257 48.2818C26.5138 48.6183 26.8734 48.8596 27.2798 48.968C27.4699 50.2576 27.9447 51.4873 28.6691 52.5658C29.3934 53.6442 30.3487 54.5436 31.4638 55.1973V62.304L23.5627 70.2496C23.3797 70.4336 23.2355 70.6532 23.1389 70.8952C23.0422 71.1372 22.9951 71.3965 23.0004 71.6575C23.0025 72.1681 23.2048 72.6571 23.5627 73.0171L26.9367 76.4307C27.2925 76.7928 27.7758 76.9974 28.2805 76.9996C28.5384 77.005 28.7947 76.9573 29.0339 76.8595C29.2731 76.7617 29.4902 76.6158 29.672 76.4307L39.4793 66.4504C39.8372 66.0904 40.0395 65.6014 40.0416 65.0908V55.2069C41.1499 54.5592 42.1009 53.6688 42.8249 52.6009C43.5489 51.5331 44.0275 50.3148 44.2256 49.0355H72.5609C73.0664 49.0355 73.5513 48.8323 73.9088 48.4707C74.2662 48.109 74.4671 47.6184 74.4671 47.107V46.1427H77.3263C77.8319 46.1427 78.3167 45.9395 78.6742 45.5778C79.0317 45.2161 79.2325 44.7256 79.2325 44.2141V29.9524L83.3308 26.3943C83.627 26.1387 83.8387 25.7974 83.9376 25.4165C84.0364 25.0355 84.0175 24.633 83.8836 24.2632ZM36.2292 64.2904L28.2805 72.3421L27.6038 71.6575L34.7138 64.464C35.0718 64.104 35.274 63.615 35.2762 63.1043V56.3544H36.2292V64.2904ZM70.6547 45.1784H43.9683C43.5365 43.7416 42.7435 42.4428 41.6669 41.4089C40.5903 40.375 39.267 39.6415 37.8263 39.28C36.3857 38.9185 34.8769 38.9415 33.4476 39.3466C32.0183 39.7517 30.7174 40.5252 29.672 41.5913V38.4285H68.7486C69.2029 38.4285 69.6423 38.2643 69.9876 37.9656L70.6547 37.387V45.1784ZM75.4202 42.2856H74.4671V34.0796L75.4202 33.2503V42.2856Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_244",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_244",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSystem);
export default __webpack_public_path__ + "static/media/videoSystem.a2003d462c517d1a0440b0644a3f92c9.svg";
export { ForwardRef as ReactComponent };